import { gql } from "@apollo/client"

export const AGGREGATE_ADMIN_ROLE = gql`
	query(
		$where: AdminRoleWhereInput
		$orderBy: [AdminRoleOrderByWithRelationInput]
		$cursor: AdminRoleWhereUniqueInput
		$take: Int
		$skip: Int
	){
		aggregateAdminRole(
			where: $where
			orderBy: $orderBy
			cursor: $cursor
			take: $take
			skip: $skip
		){
			_count{
				id
				createdAt
				updatedAt
				title
				description
				canObject
				canBlog
				canReview
				canChangeRole
				_all
			}
			_min{
				id
				title
				description
				canObject
				canBlog
				canReview
				canChangeRole
			}
			_max{
				id
				title
				description
				canObject
				canBlog
				canReview
				canChangeRole
			}
		}
	}
`